import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Form.css';

// TODO: this class can be removed and formsy-react form can be used directly but I'll keep it for now as there may be a need to change and use it
class Form extends React.Component {

  getModel = (...data) => {
    return this.refs.form.getModel(...data);
  }

  submit = (...data) => {
    this.refs.form.submit(...data);
  }

  reset = (...data) => {
    this.refs.form.reset(...data);
  }

  render() {
    const {onSubmit, className, children, outerInfoMessage, outerErrorMessage, ...props} = this.props;
    const wrapClass = cx(s.Form_info, s.Form_info__error);
    return (
      <Formsy
        {...props}
        onValidSubmit={onSubmit}
        onChange={this.props.onChange}
        className={cx(s.Form, s[className])} 
        ref="form">
        {outerErrorMessage ? (
          <section className={wrapClass}>
            <FormattedMessage id={outerErrorMessage} />
          </section>
        ) : null}
        {outerInfoMessage ? 
          (<section className={s.Form_info}>
            <FormattedMessage id={outerInfoMessage} />
           </section>) : null}
        {children}
      </Formsy>
    );
  }
}

Form.propTypes = {
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
  onValid: PropTypes.func,
  onInvalid: PropTypes.func,
  outerErrorMessage: PropTypes.string,
  outerInfoMessage: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default withStyles(s)(Form);



// WEBPACK FOOTER //
// ./src/components/Form/Form.js